import { ref } from 'vue';
import type { DataTableColumn } from '@DataTableModule';

const activeColumns = ref<string[]>([]);
const columns = ref<DataTableColumn[]>([]);
const endDate = ref<string>('');
const initialColumns = ref<string[]>([]);
const page = ref<number>(1);
const rows = ref<any[]>([]);
const searchQuery = ref<string>('');
const selectedRows = ref<any[]>([]);
const selectedType = ref<string>('all');
const size = ref<'compact' | 'default' | 'large'>('default');

function reset() {
  columns.value = [];
  endDate.value = '';
  page.value = 1;
  rows.value = [];
  searchQuery.value = '';
  selectedRows.value = [];
  selectedType.value = 'all';
  size.value = 'default';
}

export default function () {
  return {
    activeColumns,
    columns,
    endDate,
    initialColumns,
    page,
    rows,
    searchQuery,
    selectedRows,
    selectedType,
    size,

    reset,
  };
}
